import { useState } from 'react'

const DragDroppableContainer = ({
  children,
  onDrop,
  isDanger,
}: {
  isDanger?: boolean
  children?: React.ReactElement
  onDrop: (data: string) => void
}): React.ReactElement => {
  const [isDropping, setIsDropping] = useState(false)

  return (
    <div
      className={`${isDropping && 'animate-pulse-fast'} w-16 h-16 border-2 mx-2 rounded-medium ${
        isDanger ? 'animate-pulse border-red' : ''
      }`}
      onDragEnter={() => setIsDropping(true)}
      onDragLeave={() => setIsDropping(false)}
      onDragOver={(e) => {
        e.preventDefault()
      }}
      onDrop={(e) => {
        setIsDropping(false)
        const data = e.dataTransfer.getData('id')
        onDrop(data)
        e.currentTarget.appendChild(document.getElementById(data) as HTMLElement)
      }}
    >
      {children}
    </div>
  )
}

export default DragDroppableContainer
